import { COMPETITION_SETUP_ROLES, type RoleCode, SPORT_SORT_KEYS } from "@seagames/contracts";
import { z } from "zod";
import { listSearch } from "../../lib/list-page/list-search";

/**
 * The sports list's search params. Shared with the disciplines drill-down,
 * which carries them in its `list` param so its back link returns to the
 * same view (games, search, status, sort, page).
 */
export const sportsListSearch = listSearch(SPORT_SORT_KEYS, {
	games_id: z.string().uuid(),
	/**
	 * A BOOLEAN here, not the "true"/"false" the API takes: TanStack Router
	 * JSON-parses each value, so `?is_active=false` arrives as `false` (see the
	 * countries page). The string branch covers a hand-typed URL.
	 */
	is_active: z.union([z.boolean(), z.enum(["true", "false"]).transform((v) => v === "true")]),
});
export type SportsListSearch = z.infer<typeof sportsListSearch>;

/** Who may add, edit and delete sports and disciplines. The API is the control; this only hides buttons. */
export const canSetUpCompetition = (role: RoleCode | null): boolean => role !== null && (COMPETITION_SETUP_ROLES as readonly RoleCode[]).includes(role);
